module.exports = __webpack_public_path__ + "img/tpc-posters-2.d3f9f792.webp";